module.exports = __webpack_public_path__ + "static/ingredients-blur-72ba0bc1d54ebd6ca22b66eeada74ba9.jpg";